import React from "react";
import {
  Card,
  CardBody,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from "@chakra-ui/react";

const NetworkMetricCard = ({ label, value, helpText }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <Card bg={cardBg} borderWidth="1px" borderColor={borderColor}>
      <CardBody>
        <Stat>
          <StatLabel>{label}</StatLabel>
          <StatNumber>{value}</StatNumber>
          {helpText ? <StatHelpText mb={0}>{helpText}</StatHelpText> : null}
        </Stat>
      </CardBody>
    </Card>
  );
};

export default NetworkMetricCard;
